module.exports = __webpack_public_path__ + "static/media/со.5d5acd2d.mp3";